export const HYCOM = {
  title: {
    value: 'HYCOM (Hybrid Coordinate Ocean Model)',
  },
  paragraph: {
    value: `The data set from HYCOM (Hybrid Coordinate Ocean Model) include global-scale ocean model data. HYCOM is a consortium of multi-institutional effort sponsored by the National Ocean Partnership Program (NOPP), as part of the U. S. Global Ocean Data Assimilation Experiment(GODAE), to develop and evaluate a data-assimilative hybrid coordinate ocean model.`,
  },
  table: {
    value: {
      header: ['General', 'Model'],
      hiddenHeaders: ['Model'],
      rows: [
        {
          General: 'Title',
          Model: 'HYCOM Global Ocean Forecasting System (GOFS) version 3.1',
        },
        {
          General: 'Geographical Coverage',
          Model: 'Global',
        },
        {
          General: 'Category',
          Model: 'Ocean Parameters',
        },
        {
          General: 'Source Name',
          Model: `HYCOM GOFS 3.1
                  Datasets: GLBy0.08 and GLBv0.08`,
        },
        {
          General: 'Publisher',
          Model: 'The HYCOM consortium for Data Assimilative Modelling',
        },
        {
          General: 'Cost (ex. VAT)',
          Model: 'Free',
        },
        {
          General: 'Typical Applications',
          Model: 'Hydrodynamic, Offshore and Marine projects',
        },
        {
          General: 'References',
          Model: `HYCOM home: ***https://www.hycom.org/*** GOFS 3.1 main page: ***https://www.hycom.org/dataserver/gofs-3pt1/analysis***`,
        },
      ],
    },
  },
  table1: {
    value: {
      header: ['Coverage', 'Model'],
      hiddenHeaders: ['Model'],
      rows: [
        {
          Coverage: 'Geographical Range',
          Model: `Global:
                  Longitude: 180°W -> 180°E 
                  Latitude: 80°S -> 90°N`,
        },
        {
          Coverage: 'Geographical Resolution',
          Model: `GLBy0.08:
                  0.08 deg. Long x 0.04 deg. Lat
                  
                  GLBv0.08:
                  0.08 deg. Long x 0.08 deg. Lat between 40S-40N.
                  0.04 deg. Long x 0.04 deg. Lat poleward of 40S/40N
                  `,
        },
        {
          Coverage: 'Vertical Reference',
          Model: 'Sea Surface',
        },
        {
          Coverage: 'Vertical Range',
          Model: 'Sea surface to Sea bed',
        },
        {
          Coverage: 'Vertical Resolution',
          Model: '41 layers',
        },
        {
          Coverage: 'Temporal Reference',
          Model: 'UTC',
        },
        {
          Coverage: 'Temporal Range',
          Model: `Data Link coverage:
                  GLBy0.08 : 4/12-2018 -> Present
                  GLBv0.08 : 1/1-2016 -> 3/12-2018 (Not yet available)`,
        },
        {
          Coverage: 'Temporal Resolution',
          Model: '3-hourly',
        },
      ],
    },
  },
  table2: {
    value: {
      header: ['Variables', 'Model'],
      hiddenHeaders: ['Model'],
      rows: [
        {
          Variables: 'Name (Unit)',
          Model: `Sea Surface Height [m]
                  Water Temperature [deg C]
                  Salinity [psu]
                  U-velocity component (East dir.) [m/s]
                  V-velocity component (North dir.) [m/s]`,
        },
      ],
    },
  },
  table3: {
    value: {
      header: ['Credits', 'Model'],
      hiddenHeaders: ['Model'],
      rows: [
        {
          Credits: 'Data product Authors and Originators',
          Model: `DOC/NOAA/NWS/NCEP > National Centers for Environmental Prediction, National Weather Service, NOAA, U.S. Department of Commerce`,
        },
        {
          Credits: 'Data product Publisher',
          Model: `NOAA National Centers for Environmental Information. DOC/NOAA/NESDIS/NCDC > National Climatic Data Center, NESDIS, NOAA, U.S. Department of Commerce`,
        },
      ],
    },
  },
};
